import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { taxesService } from "../services/tax.service";

export const fetchTaxes = createAsyncThunk("tax/fetchAll", async (_, thunkAPI) => {
  try {
    return await taxesService.getTaxes();
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to fetch taxes.");
  }
});

export const fetchTaxeById = createAsyncThunk("tax/fetchById", async (id, thunkAPI) => {
  try {
    return await taxesService.getTaxById(id);
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to fetch tax");
  }
});

export const fetchTaxByName = createAsyncThunk(
  "tax/fetchByName",
  async (name, thunkAPI) => {
    try {
      return await taxesService.getTaxByName(name);
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch tax by name");
    }
  }
);


export const addTaxe = createAsyncThunk("tax/add", async (tax, thunkAPI) => {
  try {
    return await taxesService.createTax(tax);
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to create tax");
  }
});

export const editTax = createAsyncThunk("tax/edit", async ({ id, tax }, thunkAPI) => {
  try {
    return await taxesService.updateTax(id, tax);
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to update tax");
  }
});

export const removeTax = createAsyncThunk("tax/remove", async (id, thunkAPI) => {
  try {
    await taxesService.deleteTax(id);
    return id;
  } catch (err) {
    return thunkAPI.rejectWithValue("Failed to delete tax");
  }
});

const taxSlice = createSlice({
  name: "tax",
  initialState: { taxes: [], tax: null, loading: false, error: null, showModal: false, showDeleteModal: false },
  reducers: {
    openModal: (state) => {
      state.showModal = true
    },
    closeModal: (state) => {
      state.showModal = false
    },
    openDeleteModal: (state) => {
      state.showDeleteModal = true
    },
    closeDeleteModal: (state) => {
      state.showDeleteModal = false
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTaxes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTaxes.fulfilled, (state, action) => {
        state.loading = false;
        state.taxes = action.payload;
      })
      .addCase(fetchTaxes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTaxeById.fulfilled, (state, action) => {
        state.tax = action.payload;
      })
      .addCase(addTaxe.pending, (state) => {
        state.loading = true
      })
      .addCase(addTaxe.fulfilled, (state, action) => {
        state.taxes = [action.payload, ...state.taxes]
        state.loading = false
        state.showModal = false;
      })
      .addCase(editTax.pending, (state) => {
        state.loading = true
      })
      .addCase(editTax.fulfilled, (state, action) => {
        const editedTax = action.meta.arg;
        state.taxes = state.taxes.map((t) =>
          t.taxId === editedTax.id ? { ...editedTax.tax, taxId: editedTax.id } : t
        );
        state.loading = false
        state.showModal = false;
      })
      .addCase(removeTax.pending, (state) => {
        state.loading = true
      })
      .addCase(removeTax.fulfilled, (state, action) => {
        state.taxes = state.taxes.filter((s) => s.taxId !== action.payload);
        state.loading = false;
        state.showDeleteModal = false;
      })
      .addCase(removeTax.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchTaxByName.fulfilled, (state, action) => {
        state.tax = action.payload;
      });
  },
});

export const {
  openModal,
  closeModal,
  openDeleteModal,
  closeDeleteModal
} = taxSlice.actions;
export default taxSlice.reducer;